var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPunc = function SvgPunc(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 270 270"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#punc_svg__a)",
    d: "M192.243 67.78s6.611 86.06-19.241 126.97c-7.31 11.56-29.472 13.25-38 13.25s-30.692-1.69-38-13.25C71.15 153.84 77.76 67.78 77.76 67.78c0-3.19 25.631-5.78 57.243-5.78s57.239 2.59 57.239 5.78"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#punc_svg__b)",
    d: "M80 140c0 4.418 24.185 8 54.934 8S190 144.418 190 140s-24.316-8-55.066-8S80 135.582 80 140"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "punc_svg__a",
    x1: 135.002,
    x2: 135.002,
    y1: 206.54,
    y2: 62.146,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#1B89BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453,
    stopColor: "#2B91C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.532,
    stopColor: "#61ADD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.612,
    stopColor: "#8FC5DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.692,
    stopColor: "#B4D8E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.771,
    stopColor: "#D1E7F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.849,
    stopColor: "#E6F2F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.926,
    stopColor: "#F2F8FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7FBFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "punc_svg__b",
    x1: 135,
    x2: 135,
    y1: 148.608,
    y2: 124.192,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A91BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.344,
    stopColor: "#3295C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.905,
    stopColor: "#4BA2C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#50A5CB"
  })))));
};
export default SvgPunc;